import { z } from 'zod';
/**
 * Teacher schema - a leader in a study group
 */
export const TeacherSchema = z.object({
    id: z.string(),
    name: z.string().min(1),
});
/**
 * Teacher assignment schema - a teacher's assignment within a study
 */
export const TeacherAssignmentSchema = z.object({
    teacher: TeacherSchema,
    reviewQuestion: z.string().nullable(),
});
//# sourceMappingURL=teacher.js.map